/* Pooch - the header search prompt cycles through words, the way Mamaearth does.
   "Search for " stays put and only the word after it rolls over: the old word
   leaves upward while the new one comes up from below, so the line is never empty.
   The prefix and the word list come from the theme's own text, so they are edited in
   Shopify admin > Content > Languages (search for "pooch_search"), not in this file. */
(function () {
  var PAUSE = window.POOCH_SEARCH_SPEED || 2200; /* how long each word is held, in ms - Customize > Theme settings */
  var SLIDE = 420; /* must match the transition in pooch-polish.css */

  function terms() {
    var raw = window.POOCH_SEARCH_TERMS || '';
    var list = String(raw)
      .split('|')
      .map(function (t) {
        return t.trim();
      })
      .filter(Boolean);
    return list;
  }

  function targets() {
    var found = [];
    var buttons = document.querySelectorAll('search-button.search-action--text .header-actions__action');
    for (var i = 0; i < buttons.length; i++) {
      var spans = buttons[i].querySelectorAll('span');
      for (var j = 0; j < spans.length; j++) {
        var span = spans[j];
        /* the label span holds the prompt text; the icon lives in its own wrapper */
        if (span.querySelector('svg')) continue;
        if (!(span.textContent || '').trim()) continue;
        found.push(span);
        break;
      }
    }
    return found;
  }

  function build(span, prefix, list) {
    span.textContent = '';
    var lead = document.createElement('span');
    lead.className = 'pooch-srot__lead';
    lead.textContent = prefix;

    var frame = document.createElement('span');
    frame.className = 'pooch-srot';

    var word = document.createElement('span');
    word.className = 'pooch-srot__w';
    word.textContent = list[0];

    /* the incoming word waits just below the frame */
    var next = document.createElement('span');
    next.className = 'pooch-srot__w pooch-srot__w--next';
    next.textContent = list.length > 1 ? list[1] : list[0];

    frame.appendChild(word);
    frame.appendChild(next);
    span.appendChild(lead);
    span.appendChild(frame);
    return { frame: frame, word: word, next: next };
  }

  /* change the existing text instead of putting in a new text node: a new node inside the header made
     Horizon's body:has(...) rules re-check, and the browser restyled the whole page every word */
  function setWord(el, text) {
    var n = el.firstChild;
    if (n && n.nodeType === 3 && !n.nextSibling) { if (n.data !== text) n.data = text; }
    else el.textContent = text;
  }

  function run(parts, list) {
    var i = 0;
    setInterval(function () {
      i = (i + 1) % list.length;
      for (var n = 0; n < parts.length; n++) {
        (function (p) {
          setWord(p.next, list[i]);
          p.frame.classList.add('is-roll');
          setTimeout(function () {
            /* the new word is now in place - put it back in the resting slot without animating */
            p.frame.classList.add('is-reset');
            p.frame.classList.remove('is-roll');
            setWord(p.word, list[i]);
            /* 12 Oct: offsetHeight padhne se poore page ka naap dobara hota tha (~100ms atak, hover
               jhatke se chalta tha). Ab do frame baad animation wapas — wahi asar, bina atak. */
            requestAnimationFrame(function () {
              requestAnimationFrame(function () { p.frame.classList.remove('is-reset'); });
            });
          }, SLIDE);
        })(parts[n]);
      }
    }, PAUSE + SLIDE);
  }

  function start() {
    var list = terms();
    if (list.length < 2) return; /* nothing to cycle through - leave the prompt alone */
    var prefix = window.POOCH_SEARCH_PREFIX || '';
    var spans = targets();
    if (!spans.length) return;

    var parts = [];
    for (var i = 0; i < spans.length; i++) parts.push(build(spans[i], prefix, list));
    run(parts, list);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
